import { API_BASE } from "../AppConfig";
import { fetchTimeout } from "../components/Common";
import { SHOW_LOADING_BACKDROP, SHOW_LOADING_BAR, UPDATE_DESIGNER, updateDesigner } from "./appState";
import { updateLayout2D, updateLayout3D } from "./appStateHelper";
import { NEW_JOB, newDefaultJobState } from "./jobState";
import * as JOBSTATE_VALIDATION from "./jobState_Validation";
import _merge from "lodash/merge";
import _cloneDeep from "lodash/cloneDeep";

export const takeControl = () => (dispatch, getState) => {
    const job = getState()?.job;
    if (!job) return;
    const job_ts = job._ts;
    const business_code = job.BusinessCode;
    const job_id = job.id;
    const user_data = getState().app?.user;

    const THREED_MODE = getState()?.app.designer["threeDMode"];

    return new Promise((resolve) => {
        let job_url = API_BASE() + "job/" + business_code + "/" + job_id;
        fetchTimeout(job_url, {
            method: "POST", // *GET, POST, PUT, DELETE, etc.
            body: JSON.stringify({
                action: "takeControl",
                job_ts: job_ts,
                user_id: user_data.id,
                user_code: user_data.UserCode,
                display_name: user_data.DisplayName,
                session_id: window?.session_id,
            }),
        }).then(async (response) => {
            if (response.status >= 200 && response.status <= 300) {
                let text = await response.text();
                if (text == "") {
                    resolve("OK, no need to update");
                } else {
                    let recall_job_data = JSON.parse(text);
                    
                    let num_areas = recall_job_data?.AreaSpecifications.length;

                    let user_data_for_validation = user_data;
                    if (recall_job_data?.User) user_data_for_validation = recall_job_data?.User;
                    if (!user_data_for_validation?.BusinessDetails && recall_job_data?.Distributor)
                        user_data_for_validation.BusinessDetails = recall_job_data?.Distributor;

                    let job_to_load = _cloneDeep(
                        newDefaultJobState(
                            getState().config,
                            "",
                            user_data_for_validation,
                            num_areas ? num_areas : 1,
                            getState().app
                        )
                    );
                    _merge(job_to_load, recall_job_data);

                    job_to_load.App = {
                        current_SVG: "",
                        current_OBJ: "",
                    };
                    window.svg = "XYZ";

                    job_to_load = JOBSTATE_VALIDATION.validateFullJob(
                        getState().config,
                        job_to_load,
                        -1,
                        getState().app
                    );

                    dispatch(updateDesigner(SHOW_LOADING_BACKDROP, false));

                    dispatch({
                        type: UPDATE_DESIGNER,
                        parameter: SHOW_LOADING_BAR,
                        value: false,
                    });

                    dispatch({
                        type: NEW_JOB,
                        parameter: job_to_load,
                    });
                    if (THREED_MODE) {
                        dispatch(updateLayout3D());
                    } else {
                        dispatch(updateLayout2D());
                    }
                }
            } else resolve("ERROR");
        });
    });

    // return new Promise((resolve) => {
    //     let job_url = API_BASE() + "job/" + business_code + "/" + job_id + "/Control";
    //     fetchTimeout(job_url, {
    //         method: "GET", // *GET, POST, PUT, DELETE, etc.
    //     }, 30000)
    //         .then(async response => {

    //             let documents = JSON.parse(await response.text());
    //             if (documents.length > 0) {

    //                 //merge with template
    //                 let recall_job_data = { ...documents[0] };
    //                 
    //                 let num_areas = recall_job_data?.AreaSpecifications.length;
    //                 let job_to_load = _cloneDeep(newDefaultJobState(getState().config, "", user_data, num_areas ? num_areas : 1));
    //                 _merge(job_to_load, recall_job_data);

    //                 job_to_load.App = {
    //                     current_SVG: "",
    //                     current_OBJ: "",
    //                 }

    //                 job_to_load = JOBSTATE_VALIDATION.validateFullJob(getState().config, job_to_load, -1, getState().app);

    //                 dispatch({
    //                     type: NEW_JOB,
    //                     parameter: job_to_load,
    //                 });
    //                 saveJobBasic(job_to_load);
    //                 return resolve(true);
    //             }
    //             else {
    //                 throw new Error("No Job");
    //             }
    //         })
    //         .catch((e) => {
    //             // dispatch(setDesignerLoadingBackdrop("ERROR LOADING JOB #" + job_id));
    //             
    //             return resolve(false);
    //             // handle errors and timeout error
    //         }) // parses JSON response into native Javascript objects
    // });
};
